import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// i18next
import { useTranslation } from 'react-i18next';
// Types
import MediaFormats from 'types/MediaFormats';
// Components
import ImageUpload from 'components/ImageUpload';
import Accordion from 'components/Accordion';
import { ColorPicker } from 'components/ColorPicker';
import StyledMuiButton from 'components/StyledMuiButton';
// MUI
import { ButtonGroup } from '@material-ui/core';
// Utilities
import { isRequired } from 'utilities/validation';

const SectionImages:FC = () => {
  const { t } = useTranslation();

  const { control, formState: { errors }, watch } = useFormContext();

  const logoImageBackgroundColor = watch('logoImageBackgroundColor');
  const logoFormat = watch('logoFormat');

  return (
    <div react-scroll="images">
      <Accordion label={t('labels.images')} icon="images">
        <div className="w-full">
          <div className="mb-4">
            <Controller
              control={control} name="logoFormat"
              render={({ field: { onChange, value } }) => (
                <ButtonGroup size="small" style={{ marginBottom: '16px' }}>
                  <StyledMuiButton
                    variant={value === MediaFormats.Logo ? 'contained' : 'outlined'}
                    onClick={() => onChange(MediaFormats.Logo)}
                  >{t('labels.squareLogo')}</StyledMuiButton>
                  <StyledMuiButton
                    variant={value === MediaFormats.RectLogo ? 'contained' : 'outlined'}
                    onClick={() => onChange(MediaFormats.RectLogo)}
                  >{t('labels.rectangularLogo')}</StyledMuiButton>
                </ButtonGroup>
              )}
            />
            <Controller
              control={control} name="logoImage" rules={{ required: isRequired }}
              render={({ field }) => (
                <ImageUpload
                  {...field}
                  key={`${logoFormat}-${logoImageBackgroundColor}`}
                  format={logoFormat}
                  label="labels.logoImage"
                  className="sm:w-1/3"
                  required={true}
                  error={Boolean(errors.logoImage)}
                  errorText={errors.logoImage ? errors.logoImage.message : ''}
                  backgroundColor={logoImageBackgroundColor}
                />
              )}
            />
          </div>
          <div className="mb-4">
            <Controller
              control={control} name="logoImageBackgroundColor"
              render={({ field: { value, onChange } }) => (
                <ColorPicker
                  label={t('labels.logoImageBackgroundColor')}
                  value={value || 'rgba(255, 255, 255, 0)'}
                  onChange={onChange}
                />
              )}
            />
          </div>
          <Controller
            control={control} name="backgroundImage"
            render={({ field }) => (
              <ImageUpload
                {...field}
                className="sm:w-1/3"
                format={MediaFormats.Background}
                label="labels.backgroundImage"
              />
            )}
          />
        </div>
      </Accordion>
    </div>
  )
}

export default SectionImages;
